import { render, staticRenderFns } from "./selfList.vue?vue&type=template&id=7494fe50&scoped=true"
import script from "./selfList.vue?vue&type=script&lang=js"
export * from "./selfList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494fe50",
  null
  
)

export default component.exports